import { ValidateJSModel } from 'forms/shared/types';
import { LegalPoliceOtherOffenseModel } from './types';
import { legalPoliceOtherOffenseItemValidator } from './validators/item';

const legalPoliceOtherOffenseValidator: ValidateJSModel<LegalPoliceOtherOffenseModel> = {
  // For List, validation is the same for both PVQ and non-PVQ
  List: {
    presence: true,
    branchCollection: { validator: legalPoliceOtherOffenseItemValidator },
  },
};
export default legalPoliceOtherOffenseValidator;
